import { LinearProgress } from "@material-ui/core";
import React from "react";

function GenericLinearProgress() {
	return (
		<LinearProgress />
	);
}

export default GenericLinearProgress;